import { render, staticRenderFns } from "./alfa.vue?vue&type=template&id=4bb21adf&scoped=true"
import script from "./alfa.vue?vue&type=script&lang=js"
export * from "./alfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb21adf",
  null
  
)

export default component.exports